export const SWITCH_USER = 'SWITCH_USER';
export const LOGOUT_AND_CLEAR_STATE = 'LOGOUT_AND_CLEAR_STATE';
export const LOAD_PAGES = 'LOAD_PAGES';
export const SET_SELECTED_PAGE = 'SET_SELECTED_PAGE';
